import Cookie from 'js-cookie';

export type AffiliateInfoCookies = {
  provider?: string;
  partner?: string;
  token?: string;
};

const isEmpty = (obj: Record<string, string | undefined>) =>
  Object.values(obj).every((value) => value === undefined);

const removeEmptyFields = (obj: Record<string, string | undefined>) => {
  const filteredArr = Object.entries(obj).filter(
    ([, value]) => value !== undefined,
  );

  return Object.fromEntries(filteredArr);
};

const retrieveAffiliateInfoCookies = (): AffiliateInfoCookies | null => {
  const affiliateInfo = {
    provider: Cookie.get('affiliate_provider'),
    partner: Cookie.get('affiliate_partner'),
    token: Cookie.get('affiliate_token'),
  };

  return isEmpty(affiliateInfo) ? null : removeEmptyFields(affiliateInfo);
};

export { retrieveAffiliateInfoCookies };
